import { useDataValue } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

export function useOnClick(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  let person = useDataValue({
    context: 'person',
    viewPath: props.viewPath,
  })

  return function onClick() {
    props.onChange(person.id === 'delete' ? null : person.id)
    setFlowTo(normalizePath(props.viewPath, '../../../../No'))
  }
}
